/**
 * Interpola o tempo de countdown no texto de descrição de forma inteligente
 * @param text - Texto original da descrição
 * @param timeValue - Valor numérico do tempo (ex: 10, 15, 20)
 * @returns Texto interpolado com o tempo incluído
 */
export function interpolateCountdownText(text: string, timeValue: number): string {
  // Se o texto está vazio, retornar padrão
  if (!text || text.trim() === '') {
    return `Você será redirecionado em ${timeValue} segundos...`;
  }
  
  // Sanitizar: remover tokens {timer}, {{timer}}, [timer] e variações
  let sanitized = text
    .replace(/\{\{?timer\}?\}/gi, '')
    .replace(/\[timer\]/gi, '')
    .replace(/^\d+/g, '') // remover números soltos no início
    .replace(/\s{2,}/g, ' ')
    .trim();
  
  // Se após sanitização ficou vazio, retornar padrão
  if (!sanitized) {
    return `Você será redirecionado em ${timeValue} segundos...`;
  }
  
  // Remover "em segundos" / "em alguns segundos" residual para evitar duplicação
  sanitized = sanitized
    .replace(/\s*em\s+\d+\s+segundos?/gi, '')
    .replace(/\s*em\s+alguns\s+segundos?/gi, '')
    .replace(/[.!?…]+$/, '')
    .trim();
  
  if (!sanitized) {
    return `Você será redirecionado em ${timeValue} segundos...`;
  }
  
  return `${sanitized} em ${timeValue} segundos...`;
}

/**
 * Versão com pluralização inteligente (opcional, para versão premium)
 */
export function interpolateCountdownTextSmart(text: string, timeValue: number): string {
  const unit = timeValue === 1 ? 'segundo' : 'segundos';
  
  if (!text || text.trim() === '') {
    return `Você será redirecionado em ${timeValue} ${unit}...`;
  }
  
  let sanitized = text
    .replace(/\{\{?timer\}?\}/gi, '')
    .replace(/\[timer\]/gi, '')
    .replace(/^\d+/g, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
  
  if (!sanitized) {
    return `Você será redirecionado em ${timeValue} ${unit}...`;
  }
  
  sanitized = sanitized
    .replace(/\s*em\s+\d+\s+segundos?/gi, '')
    .replace(/\s*em\s+alguns\s+segundos?/gi, '')
    .replace(/[.!?…]+$/, '')
    .trim();
  
  if (!sanitized) {
    return `Você será redirecionado em ${timeValue} ${unit}...`;
  }
  
  return `${sanitized} em ${timeValue} ${unit}...`;
}
